var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.395,
    height: 40,
    viewBox: "0 0 27.395 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M46.425,46.992l0,.113.065-.022Z",
    transform: "translate(-35.607 -33.246)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M62.916,45.955",
    transform: "translate(-41.509 -32.875)",
    fill: "#35a7cf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M50.721,74.423,44.4,73.082l.963,9.114c.258.062.519.119.782.167A13.694,13.694,0,0,0,60.035,76.4Z",
    transform: "translate(-34.883 -42.582)",
    fill: "#0e7e99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M65.8,61.22a13.626,13.626,0,0,0-3.253-8.457l-5.069,8.789-3.229,5.6,9.314,1.975c.1-.159.206-.322.3-.486A13.62,13.62,0,0,0,65.8,61.22Z",
    transform: "translate(-38.406 -35.312)",
    fill: "#155f70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M37.5,39.478V31.135L29.58,25.586V51.8h0c0,.163,0,.328.005.492.013.419.047.833.1,1.241L38.4,49.651l5.9-2.632Z",
    transform: "translate(-29.58 -25.586)",
    fill: "#00beeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M58.019,49.926a13.7,13.7,0,0,0-16.073-3.409l6.8,7.543,4.328,4.8,5.069-8.789C58.1,50.024,58.061,49.974,58.019,49.926Z",
    transform: "translate(-34.005 -32.621)",
    fill: "#1c3f49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M39.163,69.5l-.679-6.428-8.716,3.886c.023.191.051.38.082.568A13.7,13.7,0,0,0,40.125,78.614Z",
    transform: "translate(-29.647 -39)",
    fill: "#079ec0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOutline);
export default __webpack_public_path__ + "static/media/logo-outline.e4d52889.svg";
export { ForwardRef as ReactComponent };